export const LEAVE_TYPE = {
    FULL_DAY: 'FULL_DAY',
    FIRST_HALF: 'FIRST_HALF',
    SECOND_HALF: 'SECOND_HALF',
};

export const LEAVE_TYPE_LABELS = {
    [LEAVE_TYPE.FULL_DAY]: 'Full Day',
    [LEAVE_TYPE.FIRST_HALF]: 'First Half',
    [LEAVE_TYPE.SECOND_HALF]: 'Second Half',
};

export const LEAVE_TYPE_OPTIONS = [
    { label: 'Full Day', value: LEAVE_TYPE.FULL_DAY },
    { label: 'First Half', value: LEAVE_TYPE.FIRST_HALF },
    { label: 'Second Half', value: LEAVE_TYPE.SECOND_HALF },
];

export const isHalfDay = (type) =>
    type === LEAVE_TYPE.FIRST_HALF || type === LEAVE_TYPE.SECOND_HALF;
